module.exports = __webpack_public_path__ + "static/media/power-hp5.9963595c.png";